// @ts-nocheck
import { AddLineToWishList, chain } from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { addListToProductStorage } from "@store/Framework/Common/Utilities/productToStorageList";
import { addToChainAfter, createChainHandler } from "@toolkit/Modules/client-framework/HandlerCreator";

export const AddListIdToProduct = createChainHandler("AddListIdToProduct", chain, props => {
    if (!props.result.wishList || props.result?.errorMessage) {
        return;
    }

    const productIds = props.parameter.productInfos.map(productInfo => productInfo.productId);
    addListToProductStorage(props.result.wishList.id, productIds);
});

addToChainAfter(chain, AddLineToWishList, AddListIdToProduct);
